import Swal from "sweetalert2";
import axios from "./axios.js";
import responseAlert from "./sweet_alert.js";

const request = {
  get: (url, options) => {
    return new Promise((resolve, reject) => {
      // const loader = $loading.show({});
      // JsLoadingOverlay.show(loading_options);
      axios
        .get(url, options)
        .then((res) => {
          if (res?.data?.status) {
            // loader.hide();

            resolve(res?.data);
          } else {
            // JsLoadingOverlay.hide();
            // loader.hide();

            reject();
          }
        })
        .catch((e) => {
          console.log("http request error", { e });
          responseAlert("error", e.message);

          // loader.hide();
        });

      // loader.hide();
    });
  },
  post: (url, payload, options) => {
    // let loader;
    if (!url.includes("search")) {
      // loader = $loading.show();
    }
    return new Promise((resolve, reject) => {
      axios
        .post(url, payload, options)
        .then((res) => {
          if (res.data.status) {
            resolve(res?.data);
            if (
              url?.includes("search") ||
              url?.includes("paginate") ||
              options?.isSearchApi
            ) {
              console.log("search request");
              // loader.hide();
            } else {
              responseAlert("success", "نجاح", res?.data?.msg);
              // loader.hide();
            }
          } else {
            // loader.hide();
            responseAlert("error", "خطاء", res?.data?.msg);
            reject();
          }
        })
        .catch((e) => {
          console.log("http request error", { e });
          // loader.hide();

          if (url.includes("search")) {
            console.log("search request");
          } else {
            console.log("paginate error");
            responseAlert("error", "خطاء", e.message);
          }
        });
      if (url.includes("search")) {
        console.log("search request");
      } else {
        // loader.hide();
      }
    });
  },
  put: (url, payload, options) => {
    return new Promise((resolve, reject) => {
      // const loader = $loading.show({
      //   // Optional parameters
      // });
      axios
        .put(`${url}`, payload, options)
        .then((res) => {
          if (res.data.status) {
            // loader.hide();
            responseAlert("success", "نجاح", "تم التعديل بنجاح");
            resolve(res.data);
          } else {
            // loader.hide();
            responseAlert("warning", "تنبيه", res?.data?.msg);
            reject();
          }
        })
        .catch((e) => {
          console.log("http request error", { e });
          // loader.hide();
          responseAlert("error", "خطاء", e.message);
        });
      // loader.hide();
    });
  },
  delete: (url, options) => {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "هل انت متأكد ؟",
        text: "لن تستطيع استعادة العنصر بعد الحذف !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم , قم بالحذف",
        cancelButtonText: "لا, الغاء الحذف!",
        reverseButtons: true,
      })
        .then((result) => {
          if (result?.isConfirmed) {
            // let loader = $loading.show();
            axios.delete(`${url}`, options).then((res) => {
              if (res?.data?.status) {
                console.log("deleted data");
                responseAlert("success", "نجاح", "تم الحذف بنجاح");

                resolve(res?.data);
              } else {
                responseAlert("error", "خطاء", res?.data?.msg);
                reject();
              }
              //   loader.hide();
            });
          }
        })
        .catch((e) => {
          console.log("http request error", { e });
          responseAlert("error", "خطاء", e?.message);
        });
    });
  },
};

export default request;
